<template>
    <div>
        <h1 class="font-bold text-4xl mb-20">
            Welcome,
            <a
                :href="`https://gravatar.com/emails`"
                rel="nofollow noopener"
                target="_blank">
                <img
                    :src="`${user.gravatar_url}&s=50`"
                    alt=""
                    class="inline-block rounded-full border-1 border-indigo-400 "
                    height="50"
                    width="50">
            </a>
            {{ user.name }}
        </h1>

        <p>Thanks for giving digitalnomadcafes.com a try. I don't have a lot of spare time to work on this project, so
            it's a bit limited in some
            features. If you would like to delete your account, please send me a Tweet or an email at max@maxkorlaar.com
            and I'll delete your account
            immediately, no questions asked – also see the
            <router-link class="text-indigo-400 underline hover:text-pink-500 focus:text-pink-500" to="/privacy">
                privacy statement
            </router-link>
            .
            If you have feedback or questions you can also reach me the same way.
        </p>

        <h3 class="font-bold text-2xl my-20">Account information</h3>
        <form
            @submit.prevent="updateAccount"
        >
            <FormInput
                v-model="formData.name"
                :disabled="updatingUser"
                :errors="errors.name"
                label="Name"
                required
            />

            <FormInput
                v-model="formData.email"
                :disabled="updatingUser"
                :errors="errors.email"
                label="Email"
                required
                type="email"
                help-text="Your email is used for notification emails, logging in and to display an avatar for your profile."
            >
                <template v-if="verifyEmail"
                          #after-input>
                    <p v-if="verifyEmail" class="mt-5 text-white px-10 py-5 bg-pink-500 rounded">
                        Please check your inbox with instructions on how to verify your new email address. Your current
                        email
                        address won't be updated until you verify the new one.
                    </p>
                </template>
            </FormInput>

            <FormCheckbox
                v-model="formData.attribute_in_tweets"
                :disabled="updatingUser"
                :errors="errors.attribute_in_tweets"
                label="Attribute me by mentioning my name or Twitter-username (if connected) in Tweets sent out by @NomadCafes"
            />

            <FormCheckbox
                v-model="formData.show_name_on_site"
                :disabled="updatingUser"
                :errors="errors.show_name_on_site"
                label="Show my name and avatar publicly"
            />

            <button
                :class="{ 'cursor-wait': updatingUser }"
                :disabled="updatingUser"
                class="bg-indigo-400 px-15 py-10 text-white rounded transition-colors hover:bg-pink-500 focus:bg-pink-500"
                type="submit">
                Save
            </button>
        </form>

        <h4 class="font-bold text-xl my-20">Connected accounts</h4>
        <ul class="list-disc">
            <li v-if="user.twitter_id !== null">Twitter/X ({{ user.twitter_username }})</li>
        </ul>
        <p class="mt-20">It is currently not possible to unlink connected accounts, however you're always free to revoke
            digitalnomadcafes.com's
            access to your account on the service itself. Unlinking accounts will be made possible in the future.</p>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import FormInput from "../../components/FormInput";
import FormCheckbox from "../../components/FormCheckbox.vue";

export default {
    name: "Profile",
    components: {FormCheckbox, FormInput},
    data() {
        return {
            formData: {},
            errors: {},
            verifyEmail: false
        }
    },
    methods: {
        updateAccount() {
            this.updateUser(this.formData);
        },
        ...mapActions([
            'updateUser'
        ])
    },
    computed: {
        ...mapState([
            'user',
            'updatingUser',
            'updatingUserError'
        ])
    },
    created() {
        this.formData = {
            name: this.user.name,
            email: this.user.email,
            attribute_in_tweets: this.user.attribute_in_tweets,
            show_name_on_site: this.user.show_name_on_site,
        }
    },
    watch: {
        updatingUserError(error) {
            if (error !== null) {
                this.errors = error.response?.data?.errors ?? {};
            } else {
                this.errors = {};
            }
        },
        updatingUser(updating, old) {
            if (updating === false && old === true) {
                this.verifyEmail = this.formData.email.toLowerCase() !== this.user.email;
            }
        }
        // user(user, old) {
        //     if (user && old === undefined) {
        //         this.formData = {
        //             name:  user.name,
        //             email: user.email
        //         }
        //     }
        // }
    }
}
</script>
